export const loaderConstants={
    LOADER_START:'GLOBAL_LOADER_START',
    LOADER_END:'GLOBAL_LOADER_END'
}